import type { AuthClientKey } from '@web/dtos';

export function authClientForUrl(url: string): AuthClientKey {
  const path = url.split(/[?#]/, 1)[0];
  return path === '/cms' || path.startsWith('/cms/') ? 'cms' : 'shop';
}
